/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganisationInfo
 */
export interface OrganisationInfo {
    /**
     * 
     * @type {string}
     * @memberof OrganisationInfo
     */
    inn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganisationInfo
     */
    kpp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganisationInfo
     */
    name?: string | null;
}

/**
 * Check if a given object implements the OrganisationInfo interface.
 */
export function instanceOfOrganisationInfo(value: object): value is OrganisationInfo {
    return true;
}

export function OrganisationInfoFromJSON(json: any): OrganisationInfo {
    return OrganisationInfoFromJSONTyped(json, false);
}

export function OrganisationInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganisationInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'inn': json['inn'] == null ? undefined : json['inn'],
        'kpp': json['kpp'] == null ? undefined : json['kpp'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function OrganisationInfoToJSON(json: any): OrganisationInfo {
    return OrganisationInfoToJSONTyped(json, false);
}

export function OrganisationInfoToJSONTyped(value?: OrganisationInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inn': value['inn'],
        'kpp': value['kpp'],
        'name': value['name'],
    };
}

